import { createContext, Dispatch, ReactNode, SetStateAction, useCallback, useContext, useState } from 'react';

type ContextType = {
    isSnackBarOpen: boolean;
    setIsSnackBarOpen: Dispatch<SetStateAction<boolean>>;
    snackBarMessage: string;
    setSnackBarMessage: Dispatch<SetStateAction<string>>;
    onSnackbarOpenHandler: (message: any) => void;
};

const SnackBarContext = createContext<ContextType>(undefined);

export function SnackBarContextProvider({ children }: { children: ReactNode }) {
    const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const onSnackbarOpenHandler = useCallback(
        (message: string) => {
            setSnackBarMessage(message);
            setIsSnackBarOpen(true);
        },
        [setIsSnackBarOpen, setSnackBarMessage],
    );

    return (
        <SnackBarContext.Provider
            value={{ isSnackBarOpen, setIsSnackBarOpen, snackBarMessage, setSnackBarMessage, onSnackbarOpenHandler }}
        >
            {children}
        </SnackBarContext.Provider>
    );
}

export function useSnackBarState(): ContextType {
    const state = useContext(SnackBarContext);
    if (!state) throw new Error('CountryProvider not found');
    return state;
}
